/**
 * Created by idea on 23/03/2017.
 */
import * as fromAuth from './authentication';

import {ActionReducer, combineReducers} from '@ngrx/store';
import {storeFreeze} from 'ngrx-store-freeze';
import {compose} from '@ngrx/core/compose';
import {environment} from '../../../environments/environment';
import {createSelector} from 'reselect';

export interface State {
    authentication : fromAuth.State
}

const reducers = {
    authentication : fromAuth.reducer
};


const developmentReducer: ActionReducer<State> = compose(storeFreeze, combineReducers)(reducers);
const productionReducer: ActionReducer<State> = combineReducers(reducers);

export function reducer(state: any, action: any) {
    if (environment.production) {
        return productionReducer(state, action);
    } else {
        return developmentReducer(state, action);
    }
}


/**
 * A selector function is a map function factory. We pass it parameters and it
 * returns a function that maps from the larger state tree into a smaller
 * piece of state. This selector simply selects the `books` state.
 *
 * Selectors are used with the `select` operator.
 *
 * ```ts
 * class MyComponent {
 * 	constructor(state$: Observable<State>) {
 * 	  this.booksState$ = state$.select(getCategorysState);
 * 	}
 * }
 * ```
 */


/**
 * Every reducer module exports selector functions, however child reducers
 * have no knowledge of the overall state tree. To make them useable, we
 * need to make new selectors that wrap them.
 *
 * The createSelector function from the reselect library creates
 * very efficient selectors that are memoized and only recompute when arguments change.
 * The created selectors can also be composed together to select different
 * pieces of state.
 */



export const getUserState = (state : State) => state.authentication;

export const getUser = createSelector(getUserState,fromAuth.getUser);




// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/reducers/index.ts